import { ThemeProvider } from "@emotion/react";
import Box from "@mui/material/Box";
import { createTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import BigNormalButton from 'components/atoms/Button/BigNormalButton';
import * as React from "react";
import "swiper/css";
import "swiper/css/pagination";
import useStyles from "./All.styles";

const colortheme = createTheme({
  palette: {
    primary: {
      main: "#292739",
    },
  },
  typography: {
    fontFamily: ["lato"].join(","),
  },
});

const Discover = () => {
  const illustration = require("assets/Board/illustration_2.png");
  const header = require("assets/header.png");
  
  const classes = useStyles();

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
      <Box
          style={{
            position: "absolute",
          }}
        >
          <img src={header} alt={"img"} style={{height:"430px",width:"100%"}}/>
          </Box>
        <Box
          className={classes.body}
          style={{ paddingRight: "30px", paddingLeft: "30px" }}
        >
          <Box className={classes.skipTextSection}>
            <Typography
              className={classes.detailText}
              style={{ paddingBottom: "0px" }}
            >
              skip
            </Typography>
          </Box>
          <Box
            className={classes.illustrationSection}
            style={{ paddingTop: "60px" }}
          >
            <img src={illustration} alt={"img"} />
          </Box>
          <Box className={classes.titleTextSection}>
            <Typography className={classes.titleText}>
              Discoverability
            </Typography>
          </Box>
          <Typography className={classes.detailText}>
            Our platform brings you content catered to what you want to see. If
            you’re a creator, our platform gives you the ability to showcase
            your artwork, dance moves, or even skits to potential collectors.
          </Typography>
          <Box className={classes.buttonSection}>
            <BigNormalButton color={"yellow"} text={"Next"} />
          </Box>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default Discover;
